module.exports = __webpack_public_path__ + "media/images/lp/1/achievement2-sp-39c2c3d30bde65e879314afbc2194546.png";